module.exports = __webpack_public_path__ + "img/ibmp-nasal-negative-with-symptons.d9e32e96.png";